import React, { useState } from 'react';
import { TypingTitle } from '../../agent/typing-title';
import type {
  ChatSeedChrome,
  ChatSeedChromeProps,
} from '../../chat-seed/types';

const NEW_DATASET_SEED_HEADINGS = [
  'Have Coco build it for you, or edit your dataset',
  'Get Coco to fill in your dataset, or edit it yourself',
  'Ask Coco to build it, or edit your dataset',
  'Use Coco to build or edit your dataset',
] as const;

const EXISTING_DATASET_SEED_HEADINGS = [
  'Have Coco edit it for you, or edit your dataset',
  'Get Coco to update your dataset, or edit it yourself',
  'Ask Coco to edit it, or edit your dataset',
  'Use Coco to edit or chat about your dataset',
] as const;

function pickRandomHeading(mode: 'new' | 'existing'): string {
  const headings =
    mode === 'new' ? NEW_DATASET_SEED_HEADINGS : EXISTING_DATASET_SEED_HEADINGS;
  return headings[Math.floor(Math.random() * headings.length)] ?? headings[0];
}

const DatasetChatSeedHeading: React.FC<ChatSeedChromeProps> = ({ isNew }) => {
  const [heading] = useState(() =>
    pickRandomHeading(isNew === true ? 'new' : 'existing')
  );

  return <TypingTitle text={heading} className="mb-2" />;
};

export const datasetChatSeedChrome: ChatSeedChrome = {
  Heading: DatasetChatSeedHeading,
};
